import React from 'react';
import TextField from 'material-ui/TextField';

export const InputTextareaField = (props) => {
    const {
        input,
        label,
        fullWidth,
        disabled,
        helperText,
        InputLabelProps,
        meta: {touched, error},
    } = props;

    return (
        <div>
            <TextField
                multiline
                label={label}
                className="textAreaFormField"
                margin="normal"
                fullWidth={fullWidth}
                disabled={disabled}
                value={input.value}
                helperText={helperText}
                InputLabelProps={InputLabelProps}
                error={touched && error ? true : false}
                {...input}
            />
            <br />
            {touched && error && <span className="errMsg"> {error} </span>}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/fields/field_input_textarea.js